import { render, staticRenderFns } from "./LargePricingTable.vue?vue&type=template&id=477f4778"
import script from "./LargePricingTable.vue?vue&type=script&lang=js"
export * from "./LargePricingTable.vue?vue&type=script&lang=js"
import style0 from "./LargePricingTable.vue?vue&type=style&index=0&id=477f4778&prod&lang=scss&module=%24s"




function injectStyles (context) {
  
  this["$s"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports